import { Capacitor } from "@capacitor/core";

export const isNativeApp = () => Capacitor.isNativePlatform();
export const isNativeAndroid = () => Capacitor.getPlatform() === 'android';
export const isNativeIOS = () => Capacitor.getPlatform() === 'ios';
